import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import {CoreModule, SETTINGS, TranslationService} from '@lv1871/core';
import {moduleInitializerFactory} from './services/setup/moduleInitializer.factory';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ALL_COMPONENTS} from './components/all.components';
import * as de from './translations/de';
import {DialogToolboxModule} from '../lib-dialog-toolbox';
import {NoAuthorizationInterceptor} from './services/no-authorization-interceptor';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {OverlayContainer} from '@angular/cdk/overlay';
import {MicrofrontendOverlayContainer} from './components/cdk/overlay/microfrontend-overlay-container';


@NgModule({
  declarations: [...ALL_COMPONENTS],
  imports: [FormsModule, CommonModule, CoreModule, DialogToolboxModule],
  exports: [...ALL_COMPONENTS],
})
export class AntragsannahmeModule {
  constructor(private _translationService: TranslationService) {
    this._translationService.addTranslations('de', de.translations);
  }

  public static forRoot(): ModuleWithProviders<AntragsannahmeModule> {
    return {
      ngModule: AntragsannahmeModule,
      providers: [
        provideAppInitializer(() => {
        const initializerFn = (moduleInitializerFactory)(inject(TranslationService), inject(SETTINGS));
        return initializerFn();
      }),
        // { provide: OverlayContainer, useClass: MicrofrontendOverlayContainer },
        {provide: HTTP_INTERCEPTORS, useClass: NoAuthorizationInterceptor, multi: true}
      ],
    };
  }
}
